import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function SubmitNotification({ open, onSubmit, setOpen, loading }) {
  const handleSubmit = () => {
    onSubmit();
    setOpen(false);
  };
  return (
    <ModalComp
      title="Submit Alert/Notification for approval?"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          primaryBtnvariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnloading={loading}
          handleSecondaryBtn={handleSubmit}
          secondaryBtnText="Submit"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      You can no longer edit the content of this notification.
    </ModalComp>
  );
}

export default SubmitNotification;
